<div class="modal-header">
	<button type="button" class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">{{TR "Gerät hinzufügen"}}</h4>
</div>
<div class="modal-body">
	<div class="wizard-header two clearfix">
		<ul class="steps">
			<li class="first {{#COMPARE activeTab '==' 1}}current{{else}}done{{/COMPARE}}">
				<div>
					<span class="number">1.</span> {{TR "Gerätetyp"}}
				</div>
			</li>
			{{#COMPARE activeTab '==' 1}}
			<li class="disabled last">
			{{else}}
			<li class="last current">
			{{/COMPARE}}
				<div>
					<span class="number">2.</span> {{TR "Konfiguration"}}
				</div>
			</li>
		</ul>
	</div>
	{{#COMPARE activeTab '==' 1}}
	<div class="panel-group" id="accordion">
		{{#unless hideAccordion}}
		<div class="panel panel-default">
			<div class="panel-heading">
				<h4 class="panel-title">
					<a data-toggle="collapse" data-parent="#accordion" href="#collapse1" id="js-active">{{TR "Direkt verbunden"}}</a>
				</h4>
			</div>
			<div id="collapse1" class="panel-collapse collapse{{#COMPARE deviceType '==' 'active'}} in{{/COMPARE}}">
				<div class="wizard panel-body">
		{{/unless}}
		{{#if showActive}}
			<p>{{{TR "Direkt mit dem Portal verbundene Geräte müssen <strong>innerhalb von 48 Stunden</strong> auf SAM DIGITAL registriert werden. Sollte Ihr Gerät schon länger eingeschaltet sein, starten Sie es bitte neu."}}}</p>
			<p><strong>{{TR "Bitte geben Sie die Geräte-ID (MAC-Adresse) ein:"}}</strong></p>

			<div class="row">
				<div class="col-sm-8 col-xs-12">
					<div class="p-t-10 p-b-10">
						<label for="connected_to_id-input wizard label-mac">00:E0:99:</label style="">
						<input type="text" class="form-control input-field-mac {{#if errors.mac}}parsley-error{{/if}}" id="connected_to_id-input" name="connected_to_id" placeholder="{{TR "XX:XX:XX"}}" minlength="6" maxlength="8" value="{{form.gateway_id}}" />
						{{#if errors.mac}}
						<ul class="parsley-errors-list filled" id="js-gateway_id-error">
						<li class="parsley-required">
							{{TR errors.mac}}{{#if errors.sysErr}} ({{ERROR_TR errors.sysErr}}){{/if}}
						</li>
						</ul>
						{{/if}}
					</div>
					<p>{{TR "Die Geräte-ID finden Sie auf einem Aufkleber am Gerät."}}</p>
				</div>
				<div class="col-sm-4 hidden-xs">
					<img class="full-width" src="\img\mac.png" alt="MAC address label">
				</div>
			</div>

		{{/if}}
		{{#unless hideAccordion}}
				</div>
			</div>
		</div>
		<div class="panel panel-default">
			<div class="panel-heading">
				<h4 class="panel-title">
					<a data-toggle="collapse" data-parent="#accordion" href="#collapse2" id="js-passive">{{TR "Indirekt verbunden"}}</a>
				</h4>
			</div>
			<div id="collapse2" class="panel-collapse collapse{{#COMPARE deviceType '!=' 'active'}} in{{/COMPARE}}">
				<div class="panel-body">
		{{/unless}}
		{{#if showPassive}}
		{{#unless hideAccordion}}
					<p>{{TR "Indirekt verbundene Geräte (z.B. Regler oder Zähler) kommunizieren nicht direkt mit dem Portal. Sie sind an einem anderen Gerät angeschlossen."}}</p>
		{{/unless}}
					{{#if availableParents}}
					<p><strong>
		{{#if hideAccordion}}
					{{TR "Angeschlossenes Gerät:"}}
		{{else}}
					{{TR "Bitte wählen Sie das angeschlossene Gerät aus:"}}
		{{/if}}
					</strong></p>
					<div class="form-group">
						{{#DEVICE_SELECT form.parent_select}}
						<select class="form-control" id="parent_select-input" name="parent_select" {{#if selectedParent}}disabled="disabled"{{/if}}>
						</select>
						{{/DEVICE_SELECT}}
					</div>
					<p><strong>{{TR "Bitte wählen Sie den Typ des neuen Gerätes aus:"}}</strong></p>
					{{#if errors.type}}
					<div class="alert alert-danger">
						{{TR errors.type}}
						{{#if errors.sysErr}}
						({{ERROR_TR errors.sysErr}})
						{{/if}}
					</div>
					{{/if}}
					{{#each availableDeviceCategories}}
					<div class="radio">
						<input type="radio" name="category" id="radio{{@index}}" value="{{this.category}}" {{#COMPARE this.category '===' ../form.category}}checked="checked"{{/COMPARE}}>
						<label for="radio{{@index}}">{{this.name}}</label>
					</div>
					{{/each}}
					{{else}}
					<div class="alert alert-warning m-t-10">
						{{TR "Sie haben momentan keinen Zugriff auf andere Geräte und können daher nur direkt verbundene Geräte registrieren."}}
					</div>
					{{/if}}
		{{/if}}
		{{#unless hideAccordion}}
				</div>
			</div>
		</div>
		{{/unless}}
	</div>
	{{else}}
	<div id="config" class="m-t-10"></div>
	{{#if contractNrList}}
    <div class="row">
        <div class="col-xs-12">            
			<div class="form-group">
				<label for="contract_nr"  class="control-label">{{TR "Vertragsnummer"}}</label>
				{{#SELECT contractNr}}
				<select
					class="selectpicker js-contract"
					data-live-search="true"
					data-style="btn-white"
					data-title="{{TR 'Vertragsnummer auswählen'}}">
					{{#each contractNrList}}
						<option value="{{idx}}">{{nr}}</option>
					{{/each}}
				</select>
				{{/SELECT}}
			</div>
        </div>
    </div>
	{{/if}}
	{{/COMPARE}}
	
</div>
<div class="modal-footer">
	<button id="ct-cancel" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
	{{#COMPARE activeTab '!=' 1}}
    <button class="btn btn-white" id="js-prev">
        <i class="glyphicon glyphicon-chevron-left"></i> {{TR "Zurück"}}
    </button>
	{{/COMPARE}}
	<button class="btn btn-primary" id="js-next">
		{{#COMPARE activeTab '==' 1}}
			{{TR "Weiter"}} <i class="glyphicon glyphicon-chevron-right"></i>
		{{else}}
			{{TR "Hinzufügen"}}
		{{/COMPARE}}
	</button>
</div>
